import AjaxHelper from '../AjaxHelper';

class PackageStore {
	constructor() {
		this.packages = new Map();
		this.subscribedPackages = new Map();
	}

	async loadPackages() {
		const that = this;

		try {
			const allPackages = await AjaxHelper.invokeServerAPIPromise('/api/getPackages', {});
			allPackages.forEach((item) => {
				that.packages.set(item.namespace, item);
			});
			const subscribedPackages = await AjaxHelper.invokeServerAPIPromise('/api/getInstalledPackages', {});
			subscribedPackages.forEach((item) => {
				that.subscribedPackages.set(item.namespace, item);
			});
		} catch (err) {
			console.log('error loading packages', err);
		}
	}

	getSubscribedPackages() {
		return this.subscribedPackages.values();
	}

	isPackageSubscribed(packageNameSpace) {
		return this.subscribedPackages.has(packageNameSpace);
	}

	static async create() {
		const o = new PackageStore();
		await o.loadPackages();
		return o;
	}
}

export default new PackageStore();
